import { observer } from "mobx-react-lite";
import { ReactNode } from "react";
import commonStyles from "./Common.module.css";

interface IFieldRow {
  label: ReactNode;
  children: ReactNode;
}

function FieldRow({ label, children }: IFieldRow) {
  if (!children) {
    return null;
  }

  return (
    <div className={commonStyles.row}>
      <div className={commonStyles.key}>{label}</div>
      <div className={commonStyles.value}>{children}</div>
    </div>
  );
};

export default observer(FieldRow);